import { API_BASE_URL } from '../App';

export async function apiClient(endpoint: string, userKey: string): Promise<Response> {
    const headers: HeadersInit = {
        'Content-Type': 'application/json',
        'Authorization': userKey
    };
    
    const response = await fetch(`${API_BASE_URL}${endpoint}`, { headers });
    return response;
}
